import { createSelector } from 'reselect';

export const latestBookingsState = (state) => state.latestBookings;

export const latestBookings = createSelector(latestBookingsState, (state) => state.bookings);

export const latestBookingsVisible = createSelector(latestBookingsState, (state) => state.visible);
